import Button from "../../components/Button";
import logo_img from "../../images/logo.png";
import red_cat from "../..//images/red_cat.svg"
import black_cat from "../..//images/black_cat.svg"
import styles from "./styles.module.css";
import { useEffect, useState } from "react";
import io from "socket.io-client";
import Button2 from "../../components/Button/btn2";

function startGame() {
  const aigame = "https://catsrps.vercel.app/?play=true";

  // Open the link in a new tab
  window.open(aigame, '_blank');

 
}

const Home = () => {
  const [numOfUsers, setNumOfUsers] = useState(0);

   
  useEffect(() => {
    const socket = io(process.env.REACT_APP_SOCKET_URL); 
    socket.on("connect", () => {
      console.log("Connected to server");
    });
    socket.on("updateUsers", (numOfUsers) => {
      setNumOfUsers(numOfUsers);
      console.log(numOfUsers)
    });
    return () => socket.disconnect();
  }, []);

  return (
    <>
      <div className={styles.left}>
        <img src={logo_img} alt="logo" className={styles.logo} />
        <div className={styles.connected} >Connected users: {numOfUsers}</div>
      </div>
      
      <div className={styles.right}>
        <img
          src={red_cat}
          alt="red_cat"
          className={styles.red_cat}
        />
        <img
          src={black_cat}
          alt="black_cat"
          className={styles.black_cat}
        />
        <div className={styles.btn_container}>
        
          <Button name="play with friend" type="friend" />
          
          <Button name="Play with stranger" type="stranger" />
          <Button2 onClick={()=>{startGame()}} name="Play with A.I." />
          
        </div>
      </div>
    </>
  );
};

export { startGame };
export default Home;
